import $ from 'jquery';
import 'magnific-popup';

class Lightbox {
    /**
     * Initialisiert die Standard-Lightbox für einzelne Bilder.
     * @param {NodeList} elements - Die gefundenen Elemente
     */
    static initStandard(elements) {
        if (elements.length > 0) {
            $(elements).magnificPopup({
                type: 'image',
                closeMarkup: '<div class="mfp-close"></div>',
                tLoading: 'Loading...',
                image: {
                    tError: '<a href="%url%">The image</a> could not be loaded.'
                },
                ajax: {
                    tError: '<a href="%url%">The request</a> failed.'
                }
            });
        }
    }

    /**
     * Initialisiert eine Galerie-Lightbox für gruppierte Bilder mit `rel`-Attribut.
     * @param {NodeList} elements - Die gefundenen Galerie-Elemente
     */
    static initGallery(elements) {
        if (elements.length > 0) {
            const galleries = new Set();

            elements.forEach(element => {
                galleries.add(element.getAttribute('rel'));
            });

            galleries.forEach(rel => {
                const galleryItems = document.querySelectorAll(`.lightbox[rel='${rel}']`);
                if (galleryItems.length > 1) {
                    $(galleryItems).magnificPopup({
                        type: 'image',
                        closeMarkup: '<div class="mfp-close"></div>',
                        tLoading: 'Loading...',
                        callbacks: {
                            buildControls: function () {
                                this.contentContainer.append(this.arrowLeft.add(this.arrowRight));
                            }
                        },
                        gallery: {
                            arrowMarkup: '<div class="mfp-arrow mfp-arrow-%dir%">%title%</div>',
                            enabled: true,
                            tPrev: '<',
                            tNext: '>',
                            tCounter: '%curr% / %total%'
                        },
                        image: {
                            tError: '<a href="%url%">The image</a> could not be loaded.'
                        },
                        ajax: {
                            tError: '<a href="%url%">The request</a> failed.'
                        }
                    });
                }
            });
        }
    }

    /**
     * Initialisiert die iFrame-Lightbox für externe Inhalte (z. B. Videos).
     * @param {NodeList} elements - Die gefundenen iFrame-Elemente
     */
    static initIframe(elements) {
        if (elements.length > 0) {
            $(elements).magnificPopup({
                type: 'iframe',
                disableOn: () => !window.matchMedia('screen and (max-width: 767px)').matches,
                closeMarkup: '<div class="mfp-close"></div>',
                tLoading: 'Loading...',
                gallery: {
                    tPrev: '<',
                    tNext: '>',
                    tCounter: '%curr% / %total%'
                },
                image: {
                    tError: '<a href="%url%">The image</a> could not be loaded.'
                },
                ajax: {
                    tError: '<a href="%url%">The request</a> failed.'
                }
            });
        }
    }
}

export default Lightbox;
